import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';

const jobs = [
  { title: 'MERN Stack Developer', desc: 'Develop robust and scalable web applications using MongoDB, Express.js, React.js, and Node.js. Collaborate with cross-functional teams to design and implement solutions that meet business requirements.' },
  { title: 'Android Developer', desc: 'Design and develop cutting-edge Android applications that deliver exceptional user experiences. Work closely with product managers and designers to translate requirements into high-quality code.' },
  { title: 'iOS Developer', desc: 'Create engaging and intuitive iOS applications using Swift and Xcode. Stay updated with the latest iOS development trends and best practices to ensure optimal performance and user satisfaction.' },
  { title: 'React.js Developer', desc: 'Build responsive and interactive user interfaces using React.js & related libraries. Collaborate with backend developers to integrate frontend components with server-side logic.' },
  { title: 'Node.js Developer', desc: 'Develop server-side applications and APIs using Node.js and related frameworks. Optimize application performance and scalability through efficient code and architecture design.' },
  { title: 'UI/UX Designers', desc: 'Create visually appealing and user-friendly interfaces for web and mobile applications. Conduct user research, wireframing, and prototyping to iterate and refine designs based on user feedback.' },
  { title: 'Testing', desc: 'Ensure the quality and reliability of our software products through comprehensive testing strategies. Develop and execute test plans, automate test cases, and identify and report defects for resolution.' },
  { title: 'Business Analyst', desc: 'Analyze business processes, requirements, and objectives to identify opportunities for improvement. Collaborate with stakeholders to define project scope, gather requirements, and document business needs.' },
  { title: 'Business Development Executive', desc: 'Identify and pursue new business opportunities, partnerships, & client engagements. Build and maintain strong relationships with clients, understand their needs, and propose tailored solutions.' },
];

export default function Career() {
  return (
    <Layout>
      {/* Page Header */}
      <section className="relative overflow-hidden min-h-[280px] md:min-h-[360px] flex items-center bg-brand-dark">
        <video className="absolute inset-0 h-full w-full object-cover opacity-40" autoPlay muted loop playsInline>
          <source src="/career.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/30 to-brand/5"></div>
        <div className="container relative z-10 py-20">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mb-4">Career</h2>
            <ul className="flex justify-center items-center gap-3 text-white/70 text-sm list-none p-0 m-0">
              <li><Link className="hover:text-brand transition-colors" to="/">Home</Link></li>
              <li><span className="text-white/40">/</span></li>
              <li className="text-brand">Career</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Jobs Section */}
      <section className="py-20 bg-white">
        <div className="container">
          {/* Header */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-brand-dark">Join Us</h2>
            <Link
              className="inline-flex items-center gap-2 bg-brand text-white font-semibold px-6 py-3 rounded-full hover:bg-brand-dark transition-colors"
              to="/internship"
            >
              Internship <i className="ontech-icons-two-up-right-arrow"></i>
            </Link>
          </div>

          <div className="row gutter-y-30">
            {jobs.map(({ title, desc }, i) => (
              <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay=".3s" key={i}>
                <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-100 overflow-hidden h-full flex flex-col">
                  {/* Card header */}
                  <div className="relative bg-brand-dark p-6 overflow-hidden">
                    <div className="absolute top-0 right-0 w-24 h-24 rounded-full bg-brand/20 -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
                    <h2 className="text-white font-bold font-heading text-xl relative z-10">{title}</h2>
                  </div>

                  {/* Card body */}
                  <div className="p-6 flex-1 flex flex-col">
                    <p className="text-gray-500 text-sm leading-relaxed flex-1 mb-6">{desc}</p>

                    <div className="border-t border-gray-100 pt-4">
                      <h3 className="text-brand font-bold font-heading text-sm mb-3">Find Us</h3>
                      <ul className="space-y-2 list-none p-0">
                        <li className="flex items-center gap-2 text-sm">
                          <span className="text-brand font-semibold">Get In Touch:</span>
                          <a href="tel:+16476874226" className="text-gray-600 hover:text-brand transition-colors">+1(647)-687-4226</a>
                        </li>
                        <li className="flex flex-col gap-0.5 text-sm">
                          <span className="text-brand font-semibold">Quick Email us:</span>
                          
                          <a href="mailto:magizhinitech@gmail.com" className="text-gray-600 hover:text-brand transition-colors">magizhinitech@gmail.com</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="w-full">
        <iframe
          src="https://maps.google.com/maps?q=44+Abelard+Ave,+Brampton,+ON+L6Y2K8,+Canada&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="w-full h-72 md:h-96 border-0 block"
          allowFullScreen=""
          title="Office map"
        ></iframe>
      </section>

      {/* Contact Info */}
      <section className="py-16 bg-gray-50">
        <div className="container">
          <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
            <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url(/assets/images/shapes/contact-info-v1-bg0.png)', backgroundSize: 'cover' }}></div>
            <div className="row relative z-10">
              {[
                { iconClass: 'icon-location-filled', label: 'Address', lines: ['44 Abelard Ave, Brampton, ON L6Y2K8, Canada.'] },
                { iconClass: 'icon-phone-auricular', label: 'Get In Touch', lines: ['+1(647)-687-4226'], hrefs: ['tel:+16476874226'] },
                { iconClass: 'icon-email2', label: 'Quick Email us', lines: ['magizhinitech@gmail.com'], hrefs: ['mailto:magizhinitech@gmail.com'] },
              ].map(({ iconClass, label, lines, hrefs }, i) => (
                <div className="col-xl-4 col-lg-4" key={i}>
                  <div className="flex items-start gap-4 mb-8 xl:mb-0">
                    <div className="flex-shrink-0 w-14 h-14 rounded-full bg-brand flex items-center justify-center text-white text-xl">
                      <span className={iconClass}></span>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 uppercase tracking-widest font-medium mb-1">{label}</p>
                      {lines.map((line, j) => (
                        hrefs ? (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">
                            <a href={hrefs[j]} className="hover:text-brand transition-colors">{line}</a>
                          </h3>
                        ) : (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">{line}</h3>
                        )
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

